var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "card-header d-flex justify-content-between align-items-center container-lg"
    },
    [
      _c(
        "form",
        {
          staticClass:
            "form-inline d-flex justify-content-center align-items-center flex-wrap form-mobile",
          attrs: { action: "/problem/", method: "GET" }
        },
        [
          _vm.tags.length !== 0
            ? _c(
                "div",
                { staticClass: "form-group mr-2" },
                [
                  _vm._l(_vm.tags, function(tag) {
                    return _c("div", { key: tag, staticClass: "mr-1" }, [
                      _c("input", {
                        attrs: { type: "hidden", name: "tag[]" },
                        domProps: { value: tag }
                      }),
                      _c(
                        "span",
                        { staticClass: "badge badge-secondary m-1 p-2" },
                        [_vm._v(_vm._s(_vm.T[tag] ? _vm.T[tag] : tag))]
                      )
                    ])
                  }),
                  _c(
                    "a",
                    {
                      staticClass: "remove-all-tags",
                      attrs: { href: "/problem/" }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fas", "times"] }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "form-group mr-2" },
            [
              _c("omegaup-common-typeahead", {
                attrs: {
                  "data-problem-keyword-search": "",
                  "only-existing-tags": false,
                  "max-results": 10,
                  "existing-options": _vm.searchResultProblems,
                  options: _vm.searchResultProblems,
                  value: _vm.currentKeyword,
                  placeholder: _vm.T.wordsKeywordSearch
                },
                on: {
                  "update:value": function($event) {
                    _vm.currentKeyword = $event
                  },
                  "update-existing-options": function(query) {
                    return _vm.$emit("update-search-result-problems", query)
                  }
                }
              }),
              _c("input", {
                attrs: { type: "hidden", name: "query" },
                domProps: { value: _vm.currentKeywordValue }
              })
            ],
            1
          ),
          _c("div", { staticClass: "form-group mr-2" }, [
            _c("label", [
              _vm._v(" " + _vm._s(_vm.T.wordsFilterByLanguage) + " "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentLanguage,
                      expression: "currentLanguage"
                    }
                  ],
                  staticClass: "ml-2 form-control",
                  attrs: { "data-filter-language": "", name: "language" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.currentLanguage = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.languages, function(language) {
                  return _c(
                    "option",
                    { key: language, domProps: { value: language } },
                    [_vm._v(" " + _vm._s(_vm.getLanguageText(language)) + " ")]
                  )
                }),
                0
              )
            ])
          ]),
          _c("div", { staticClass: "form-group mr-2" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentOnlyQualitySeal,
                    expression: "currentOnlyQualitySeal"
                  }
                ],
                staticClass: "form-check-input",
                attrs: { name: "only_quality_seal", type: "checkbox" },
                domProps: {
                  value: true,
                  checked: Array.isArray(_vm.currentOnlyQualitySeal)
                    ? _vm._i(_vm.currentOnlyQualitySeal, true) > -1
                    : _vm.currentOnlyQualitySeal
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.currentOnlyQualitySeal,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = true,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          (_vm.currentOnlyQualitySeal = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.currentOnlyQualitySeal = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.currentOnlyQualitySeal = $$c
                    }
                  }
                }
              }),
              _vm._v(" " + _vm._s(_vm.T.qualityFormQualityOnly) + " ")
            ])
          ]),
          _c("input", {
            staticClass: "btn btn-primary mr-2 button-mobile",
            attrs: { "data-filter-submit-button": "", type: "submit" },
            domProps: { value: _vm.T.wordsSearch }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }